// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"ClaimPage_layoutWrapperMain__F6aai","root":"ClaimPage_root__Y_o8P","content":"ClaimPage_content__1U4dS","termsLink":"ClaimPage_termsLink__31t8J"};